import { useEffect } from 'react'
import analytics from '@/shared-utils/analytics'
import { IGoogleAnalyticsTrackingType } from '@pcln/contentful-components'

export default function useGoogleAnalyticsTracking(
  googleAnalyticsTracking?: IGoogleAnalyticsTrackingType
) {
  useEffect(() => {
    if (googleAnalyticsTracking?.action && googleAnalyticsTracking?.label) {
      analytics.fireEvent({
        category: googleAnalyticsTracking.category
          ? googleAnalyticsTracking.category
          : 'promotion',
        action: googleAnalyticsTracking.action,
        label: googleAnalyticsTracking.label
      })
    }
  }, [googleAnalyticsTracking])
}
